const KEYS = {
  LOGIN_USER: "LUT",
  LOGIN_TOKEN: "LUT_TK",
  LANG: "LANG",
  IS_ADMIN: "IS_ADMIN",
  HOME_SCROLL_POSITION: "HOME_SCROLL_POSITION",
};
export { KEYS };
